import { AfterViewInit, Component, inject, OnInit, signal } from '@angular/core';

import { CLAIM_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME';
import { FooterService } from 'src/app/features/shared/footer/footer.service';
import { HeaderService } from 'src/app/features/shared/header/services/header.service';
import { IFooterData } from 'src/app/features/shared/footer/models/footer-data';
import { IHeaderData } from 'src/app/features/shared/header/models/header-data';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { AccountCreditsComponent } from 'src/app/features/credits/components/account-credits/account-credits.component';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { ThemeSelectorComponent } from 'src/app/core/theming/theme-selector/theme-selector.component';
import { TwoFactorSetupComponent } from '../two-factor-setup/two-factor-setup.component';
import { PeerVisibilitySettingComponent } from '../peer-visibility-setting/peer-visibility-setting.component';
import { _CentralPageService } from 'src/app/features/shared/central-page/services/_central-page.service';
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { _SectionBaseComponent } from 'src/app/infrastructure/components/section-components/_section-base-component';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { sectionLayout, TSectionLayout } from 'src/app/infrastructure/models/section-layout';

// Details-sectie van SettingsComponent. Geen _SectionDetailsComponent: dat is gebouwd rond een
// entiteit (form-model/dto); hier staan losse instellingen die elk zelf hun actie afhandelen.
// - Weergave: thema/licht-donker, direct toegepast en bewaard door ThemeSelectorComponent.
// - Credits: klantrekeningen van domains (owner of gemachtigde), ook opgeschorte (AccountCreditsComponent).
// - Tweestapsverificatie: eigen stappenproces (TwoFactorSetupComponent).
// - Privacy: projectgenoten mogen de ledenkaart openen (PeerVisibilitySettingComponent).
// Wachtwoord/e-mail wijzigen zijn accountgegevens, geen instelling: die staan in het accountmenu.
@Component({
    selector: 'app-settings-details',
    templateUrl: './settings-details.component.html',
    standalone: true,
    imports: [
        AccountCreditsComponent,
        PeerVisibilitySettingComponent,
        SharedModule,
        ThemeSelectorComponent,
        TwoFactorSetupComponent,
    ],
    styleUrls: [
        './settings-details.component.scss',
    ]
})
export class SettingsDetailsComponent
    extends _SectionBaseComponent
    implements OnInit, AfterViewInit
{
    private readonly __claimPage = inject(CLAIM_PAGE, { optional: true });

    protected override readonly _centralPageService = injectRequired(_CentralPageService);
    protected override readonly _footerService = injectRequired(FooterService);
    protected override readonly _headerService = injectRequired(HeaderService);
    protected override readonly _loadingPageService = injectRequired(LoadingPageService);
    protected override readonly _pageService = injectRequired(_PageService);

    override out_onEscape = this._out_onEscape;
    override out_onPageLoaded = this._out_onPageLoaded;

    override readonly sectionLayout$$ = signal<TSectionLayout>(sectionLayout.content);

    override template_footerLeft$$ = this._template_footerLeft$$;
    override template_sectionDetails_extraButtons$$ = this._template_sectionDetails_extraButtons$$;
    override template_sectionEdit_extraButtons$$ = this._template_sectionEdit_extraButtons$$;

    override footerData: Partial<IFooterData> = {
        hideSideBlockLeft: false,
        hideSideBlockRight: false,
    };
    override headerData: Partial<IHeaderData> = {
        title: 'instellingen',
    };

    override ngOnInit(): void {
        super._ngOnInit();
        // Knop-zichtbaarheid via de claims van deze pagina; er zijn geen BtnPage*-claims geseed,
        // dus de standaard sectieknoppen (edit/delete) blijven verborgen.
        if (this.__claimPage) this._centralPageService.pageName_sectionDetails_set(this.__claimPage);

        // De claims van deze pagina zijn al binnen via de route-resolver (Page_Read-poort).
        this.emit_pageLoaded();
    }

    override emit_onEscape(): void {
        super._emit_onEscape();
    }

    override emit_pageLoaded(): void {
        super._emit_pageLoaded();
    }

    override ngAfterViewInit(): void {
        super._ngAfterViewInit();
    }
}
